import { Component, computed, input, output } from '@angular/core';
import { AvatarModule } from 'primeng/avatar';
import { BadgeModule } from 'primeng/badge';
import { ButtonDirective } from 'primeng/button';
import { Ripple } from 'primeng/ripple';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'ui-top-bar',
  standalone: true,
  imports: [ButtonDirective, Ripple, TooltipModule, BadgeModule, AvatarModule],
  templateUrl: './top-bar.component.html',
  styleUrl: './top-bar.component.scss',
})
export class TopBarComponent {
  public readonly title = input.required();
  public readonly subtitle = input.required();
  public readonly notifyCount = input<number>(0);

  public readonly showNotifyClicked = output<void>();
  public readonly editCompanyClicked = output<void>();
  public readonly createOrderClicked = output<void>();

  protected readonly tooltipLabel = computed(() =>
    this.notifyCount() > 0
      ? 'Points to approve - click and go to order list.'
      : 'No points to approve.',
  );
}
